// extracted by mini-css-extract-plugin
export default {"container":"lW-z","title":"mW-z","link":"nW-z"};